import { CesiumContentFeatures, CesiumContentHeader } from '../types';

export interface BinaryBodyReference {
  byteOffset: number;
}

export interface PntsFeatureTable {
  POINTS_LENGTH: number;
  POSITION?: BinaryBodyReference;
  RGB?: BinaryBodyReference;
  RGBA?: BinaryBodyReference;
  RTC_CENTER: number[];

  // Defined in the Cesium structure, but currently no required or implemented
  extras: any;
  // eslint-disable-next-line @typescript-eslint/ban-types
  extensions: object;

  POSITION_QUANTIZED?: BinaryBodyReference;
  RGB565?: BinaryBodyReference;
  NORMAL?: BinaryBodyReference;
  NORMAL_OCT16P?: BinaryBodyReference;
  BATCH_ID?: BinaryBodyReference;

  QUANTIZED_VOLUME_OFFSET: number[];
  QUANTIZED_VOLUME_SCALE: number[];
  CONSTANT_RGBA: number[];
  BATCH_LENGTH: number[];
}

export interface PntsBatchTable {
  Classification: {
    byteOffset: number;
    componentType:
      | 'BYTE'
      | 'UNSIGNED_BYTE'
      | 'SHORT'
      | 'UNSIGNED_SHORT'
      | 'INT'
      | 'UNSIGNED_INT'
      | 'FLOAT'
      | 'DOUBLE';
    type: 'SCALAR' | 'VEC2' | 'VEC3' | 'VEC4';
  };
}

/**
 *  This returns the element size of the different features
 *  Currently only support position, colors and normals
 */
export const getFeatureElementSize = <K extends keyof PntsFeatureTable | keyof PntsBatchTable>(
  feature: K,
): number => {
  switch (feature) {
    case 'POSITION':
      return 3;
    case 'NORMAL':
      return 3;
    case 'RGB':
      return 3;
    case 'RGBA':
      return 4;
    case 'Classification':
      return 1;
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unsupported pnts feature: ${feature}`);
  }
};

interface PntsFeatures extends CesiumContentFeatures {
  featureTable: PntsFeatureTable;
  featureBody: ArrayBuffer;
  batchTable?: PntsBatchTable;
  batchBody?: ArrayBuffer;
}

export interface CesiumPnts {
  header: CesiumContentHeader;
  features: PntsFeatures;
}

export enum PointClass {
  Created = 0,
  Unclassified = 1,
  Ground = 2,
  LowVegetation = 3,
  MediumVegetation = 4,
  HighVegetation = 5,
  Building = 6,
  LowPoint = 7,
  ModelKeyPoint = 8,
  Water = 9,
  Rail = 10,
  RoadSurface = 11,
  OverlapPoints = 12,
  WireGuard = 13,
  WireConductor = 14,
  TransmissionTower = 15,
  WireConnector = 16,
  BridgeDeck = 17,
  HighNoise = 18,
  Car = 66,
  Manmade = 67,
}
